import bonusesData from '@/mockData/bonuses.json'

const state = {
    bonusesList: bonusesData,
}

const mutations = {
    ADD_BONUS(state, form) {
        state.bonusesList.push(form)
    }
}

const actions = {
    addbonus({ commit }, form) {
        commit('ADD_BONUS', form)
    }
}

const getters = {
    getData: state => state.bonusesList
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
